/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Class of data exported by this route.
 */
export const UpdateRouteRequestBodyDataSource = {
  ProductTelemetry: "product_telemetry",
  RiskFindings: "risk_findings",
  ToolCallLogs: "tool_call_logs",
} as const;
/**
 * Class of data exported by this route.
 */
export type UpdateRouteRequestBodyDataSource = ClosedEnum<
  typeof UpdateRouteRequestBodyDataSource
>;

export type UpdateRouteRequestBody = {
  /**
   * Class of data exported by this route.
   */
  dataSource: UpdateRouteRequestBodyDataSource;
  /**
   * Whether the route is enabled.
   */
  enabled: boolean;
  /**
   * OTEL destination configured on this route. Required when enabled.
   */
  otelDestinationId?: string | undefined;
};

/** @internal */
export const UpdateRouteRequestBodyDataSource$outboundSchema: z.ZodMiniEnum<
  typeof UpdateRouteRequestBodyDataSource
> = z.enum(UpdateRouteRequestBodyDataSource);

/** @internal */
export type UpdateRouteRequestBody$Outbound = {
  data_source: string;
  enabled: boolean;
  otel_destination_id?: string | undefined;
};

/** @internal */
export const UpdateRouteRequestBody$outboundSchema: z.ZodMiniType<
  UpdateRouteRequestBody$Outbound,
  UpdateRouteRequestBody
> = z.pipe(
  z.object({
    dataSource: UpdateRouteRequestBodyDataSource$outboundSchema,
    enabled: z.boolean(),
    otelDestinationId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      dataSource: "data_source",
      otelDestinationId: "otel_destination_id",
    });
  }),
);

export function updateRouteRequestBodyToJSON(
  updateRouteRequestBody: UpdateRouteRequestBody,
): string {
  return JSON.stringify(
    UpdateRouteRequestBody$outboundSchema.parse(updateRouteRequestBody),
  );
}
